import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {};

const defaultProps = {};

class MonthSikdaeAmount extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <h3>월별 식대 금액2</h3>
      </div>
    );
  }
}

MonthSikdaeAmount.propTypes = propTypes;
MonthSikdaeAmount.defaultProps = defaultProps;

export default MonthSikdaeAmount;
